/* ─────────────────────────────────────────────────────────────────────────────
   gb-scrollbar.js — cursore di scorrimento sempre visibile per i caroselli
   orizzontali del tema. Coppia di assets/gb-scrollbar.css.

   Per ogni contenitore che matcha SELECTOR:
     · nasconde la barra nativa (classe .gb-scrollbar-host),
     · inserisce subito dopo il contenitore una barra .gb-scrollbar con il suo
       cursore .gb-scrollbar__thumb,
     · tiene il cursore sincronizzato con scrollLeft e permette di trascinarlo
       (o di cliccare sulla traccia per saltare).

   La barra si nasconde solo se il contenuto non è scrollabile.
   I caroselli riempiti via JS (formati e pezzi speciali del variant explorer)
   cambiano contenuto senza cambiare dimensione: per questo, oltre al
   ResizeObserver, ogni host ha un MutationObserver sui figli.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  var SELECTOR = [
    '.gb-carousel', // home, home brand, pagina collezione, pagina designer
    '.galleria__grid', // galleria immagini (collezione, progetto, pagine statiche)
    '.gbc-formats', // formati (variant explorer)
    '.gbc-special', // pezzi speciali (variant explorer)
    '.gbc-thumbs', // miniature della galleria variante
    '.gbvp-subtabs', // superfici Vogue Pool
  ].join(',');

  var MIN_THUMB = 28; // px: sotto questa larghezza il cursore non si afferra più

  function setup(host) {
    if (host.dataset.gbScrollbar) return;
    host.dataset.gbScrollbar = '1';
    host.classList.add('gb-scrollbar-host');

    var bar = document.createElement('div');
    bar.className = 'gb-scrollbar';
    var thumb = document.createElement('div');
    thumb.className = 'gb-scrollbar__thumb';
    bar.appendChild(thumb);
    host.insertAdjacentElement('afterend', bar);

    var thumbWidth = 0;

    function sync() {
      var max = host.scrollWidth - host.clientWidth;
      if (max <= 1) {
        bar.hidden = true;
        return;
      }
      // Da mostrare PRIMA di misurare la traccia: da nascosta la barra
      // misurerebbe 0 e non tornerebbe mai visibile.
      bar.hidden = false;
      var track = bar.clientWidth;
      if (track <= 0) {
        // Contenitore fuori dal flusso (antenato display:none): niente da fare
        // ora, il ResizeObserver richiamerà sync quando tornerà visibile.
        bar.hidden = true;
        return;
      }
      thumbWidth = Math.max(MIN_THUMB, Math.round(track * (host.clientWidth / host.scrollWidth)));
      thumbWidth = Math.min(thumbWidth, track);
      var x = (track - thumbWidth) * (host.scrollLeft / max);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    // Posiziona lo scroll in base al punto della traccia toccato.
    // grab = distanza tra il punto afferrato e il bordo sinistro del cursore.
    function seek(clientX, grab) {
      var track = bar.getBoundingClientRect();
      var span = track.width - thumbWidth;
      var max = host.scrollWidth - host.clientWidth;
      if (span <= 0 || max <= 0) return;
      var left = clientX - track.left - grab;
      host.scrollLeft = Math.min(Math.max(left / span, 0), 1) * max;
      // Riallinea subito il cursore senza aspettare l'evento scroll: lo
      // scroll-snap può correggere scrollLeft, e il cursore deve mostrare il
      // valore effettivo, non quello richiesto.
      sync();
    }

    var grabOffset = 0;

    bar.addEventListener('pointerdown', function (e) {
      if (bar.hidden) return;
      e.preventDefault();
      var thumbRect = thumb.getBoundingClientRect();
      var onThumb = e.clientX >= thumbRect.left && e.clientX <= thumbRect.right;
      grabOffset = onThumb ? e.clientX - thumbRect.left : thumbWidth / 2;
      bar.classList.add('is-dragging');
      bar.setPointerCapture(e.pointerId);
      seek(e.clientX, grabOffset);
    });
    bar.addEventListener('pointermove', function (e) {
      if (!bar.classList.contains('is-dragging')) return;
      e.preventDefault();
      seek(e.clientX, grabOffset);
    });
    ['pointerup', 'pointercancel'].forEach(function (type) {
      bar.addEventListener(type, function (e) {
        bar.classList.remove('is-dragging');
        if (bar.hasPointerCapture && bar.hasPointerCapture(e.pointerId)) bar.releasePointerCapture(e.pointerId);
      });
    });

    host.addEventListener('scroll', sync, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(sync);
      ro.observe(host);
      ro.observe(bar);
    }
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(host, { childList: true, subtree: true });
    }
    window.addEventListener('resize', sync);
    // Le card caricano immagini lazy: rimisura quando arrivano.
    window.addEventListener('load', sync);

    sync();
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Theme editor: una sezione ricaricata porta caroselli nuovi.
  document.addEventListener('shopify:section:load', scan);
})();
